import React from "react";
import ReactDOM from "react-dom";
import "./index.scss";
import AppContainer from "./containers/AppContainer";

ReactDOM.render(
  <>
    <div>
      <AppContainer />
    </div>
  </>,
  document.getElementById("root"),
);
//@ts-ignore
if (module.hot) {
  // @ts-ignore
  module.hot.accept();
}
